module.exports = __webpack_public_path__ + "static/media/cellline_hela_summary.78d9c8df.png";